export default __webpack_public_path__ + "static/media/blueLinkIcon.4aa865ed.svg";